import Model, { AsyncBelongsTo, attr, belongsTo } from '@ember-data/model';

import type RoomControlConfigurationModel from 'admin-panel/models/room-control/configuration';

export default class RoomControlPageModel extends Model {
  @belongsTo('room-control/configuration')
  declare roomControlConfiguration: AsyncBelongsTo<RoomControlConfigurationModel>;

  @attr
  declare sectionLayout: string;

  @attr
  declare position: number;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'room-control/page': RoomControlPageModel;
  }
}
